import { USER_ROLE } from '@types';

export type TIsBulkUploadHiddenForUserParams = {
	userRoles?: string[];
	internalBulkUploadOff?: boolean | null;
};

/**
 * UI-only gating for the shipper `internal_bulkupload_off` setting.
 *
 * The flag is only respected when the signed-in user is neither `admin` nor
 * `super_admin`, so internal Ofload staff always keep bulk upload regardless of
 * the shipper setting. Everyone else (team / manager / booking manager) has bulk
 * upload hidden while the shipper has `internal_bulkupload_off` set; when the
 * flag is off their access stays governed by `bulk_upload_shipments_enabled`.
 *
 * Kept as a plain util rather than a hook because the main consumer,
 * `navigationShipper`, is a plain function invoked inside `SideNavigation` and
 * therefore cannot call `useHasRole`/`useHasAccess`. `userRoles` is already read
 * from the `UserRoles` atom by the callers and passed down, so the same helper
 * is shared by `navigationShipper`, `BookingDashboard` and `BulkUpload` instead
 * of duplicating the role comparison in three places.
 */
export const isBulkUploadHiddenForUser = ({
	userRoles = [],
	internalBulkUploadOff
}: TIsBulkUploadHiddenForUserParams): boolean => {
	if (!internalBulkUploadOff) return false;

	return !userRoles.includes(USER_ROLE.ADMIN) && !userRoles.includes(USER_ROLE.SUPER_ADMIN);
};
